import { Pipe, type PipeTransform } from '@angular/core';

const LEFT = 'left';

const currencySymbols = {
    COP: {
        symbol: '$',
        side: LEFT
    }
}

export const formatNumber = (value) => {
    const number = parseFloat(value.amount || value);

    if (isNaN(number)) {
        return 'Número no válido';
    }

    const result = number.toLocaleString('en-US');
    const currency = currencySymbols[value.currency];

    if (!currency) {
        return result;
    }

    if (currency.side === LEFT) {
        return `${currency.symbol}${result}`
    }
    return `${result}${currency.symbol}`
}

@Pipe({
  name: 'appFormatNumber',
  standalone: true,
})
export class FormatNumberPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return formatNumber(value);
  }

}
